module.exports = __webpack_public_path__ + "static/media/AIS_logo.b07cbcef.svg";